export const TKeyProjectMember = {
  PROJECT_MEMBER_COL: "PROJECT_MEMBER_COL",
  PROJECT_MEMBER_FILTER_ALL: "PROJECT_MEMBER_FILTER_ALL",
  PROJECT_MEMBER_FILTER_ME: "PROJECT_MEMBER_FILTER_ME",
  PROJECT_MEMBER_UNASSIGNED: "PROJECT_MEMBER_UNASSIGNED",
  PROJECT_MEMBER_ADD: "PROJECT_MEMBER_ADD",
  PROJECT_MEMBER_EMAIL_LABEL: "PROJECT_MEMBER_EMAIL_LABEL",
  PROJECT_MEMBER_EMAIL_PLACEHOLDER: "PROJECT_MEMBER_EMAIL_PLACEHOLDER",
  PROJECT_MEMBER_ADD_SUBMIT: "PROJECT_MEMBER_ADD_SUBMIT",
  PROJECT_MEMBER_EDIT: "PROJECT_MEMBER_EDIT",
  PROJECT_MEMBER_EDIT_SUBMIT: "PROJECT_MEMBER_EDIT_SUBMIT",
  PROJECT_MEMBER_DELETE: "PROJECT_MEMBER_DELETE",
  PROJECT_MEMBER_DELETE_WARNING: "PROJECT_MEMBER_DELETE_WARNING",
  PROJECT_MEMBER_DELETE_CONFIRM: "PROJECT_MEMBER_DELETE_CONFIRM",
  PROJECT_MEMBER_ROLE_LABEL: "PROJECT_MEMBER_ROLE_LABEL",
  PROJECT_MEMBER_ACCESS_LABEL: "PROJECT_MEMBER_ACCESS_LABEL",
  PROJECT_MEMBER_ACCESS_READER: "PROJECT_MEMBER_ACCESS_READER",
  PROJECT_MEMBER_ACCESS_EDITOR: "PROJECT_MEMBER_ACCESS_EDITOR",
  PROJECT_MEMBER_ACCESS_READER_DESC: "PROJECT_MEMBER_ACCESS_READER_DESC",
  PROJECT_MEMBER_ACCESS_EDITOR_DESC: "PROJECT_MEMBER_ACCESS_EDITOR_DESC",
  PROJECT_MEMBER_ROLE_OWNER: "PROJECT_MEMBER_ROLE_OWNER",
  PROJECT_MEMBER_ROLE_ADMIN: "PROJECT_MEMBER_ROLE_ADMIN",
  PROJECT_MEMBER_ROLE_MEMBER: "PROJECT_MEMBER_ROLE_MEMBER",
  PROJECT_MEMBER_ROLE_ADMIN_DESC: "PROJECT_MEMBER_ROLE_ADMIN_DESC",
  PROJECT_MEMBER_ROLE_MEMBER_DESC: "PROJECT_MEMBER_ROLE_MEMBER_DESC",
  PROJECT_MEMBER_INVITED: "PROJECT_MEMBER_INVITED",
} as const;
